// src/pages/Monografia/MonografiaPage.jsx
import React from 'react';
import MonografiaList from '../../components/Monografia/MonografiaList';
import { Link } from 'react-router-dom';

const MonografiaPage = () => {
    return (
        <div>
            <h1>Gestão de Monografias</h1>
            <Link to="/monografias/submeter">Submeter Nova Monografia</Link>
            <MonografiaList />
        </div>
    );
};

export default MonografiaPage;